'use strict';

class shopFilter {
  constructor () {
    this.$t = document.querySelector('.shop-filter');
    this.$form = document.getElementById('filter-form');
    this.$box = this.$t.querySelector('.shop-filter-box');
    this.$boxLines = this.$box.querySelectorAll('.shop-filter-box__line');
    this.$resultNum = this.$t.querySelector('#filter-result-num');
    this.$result = document.querySelector('.shop-result');
    this.$resultNo = this.$result.querySelector('.shop-result-no');
    this.$resultBlocks = this.$result.querySelectorAll('.shop-result-block');
    this.allChecksArr = [];
    this.params = getQueryParams();
    this.isEqualArr = (a, b) => {
      if (a.length !== b.length) return false;
      return a.every((val, i) => val === b[i]);
    };

    this.$boxLines.forEach($line => {
      let $title = $line.querySelector('.shop-filter-box__title');
      let $button = $title.querySelector(':scope > button');
      let $checks = $line.querySelector('.shop-filter-checks');
      if ($button) {
        $button.addEventListener('click', event => {
          event.preventDefault();
          this._boxLineToggle($button);
        });
      }
      if ($checks) {
        let name = $checks.dataset.name;
        this._checksItems($checks, name);
      }
    });

    this.$resultBlocks.forEach($block => {
      this._showShops($block);
    });

    this._showResultNumber();

    this.$form.addEventListener('submit', event => {
      event.preventDefault();
      this._formSubmit();
    });

  };
  _boxLineToggle = $button => {
    let controls = $button.getAttribute('aria-controls');
    let $target = document.querySelector(`#${controls}`);
    let isExpanded = $button.getAttribute('aria-expanded');
    let isHidden = $target.getAttribute('aria-hidden');
    if (isExpanded === 'false') {
      isExpanded = true;
      isHidden = false;
    } else {
      isExpanded = false;
      isHidden = true;
    };
    $button.setAttribute('aria-expanded', isExpanded);
    $target.setAttribute('aria-hidden', isHidden);
    new slideToggle($target);
  };
  _checksItems = ($checks, name) => {
    if (name) {
      let $checksItems = $checks.querySelectorAll('.shop-filter-checks__item');
      let params = this.params[name];
      $checksItems.forEach($item => {
        let $input = $item.querySelector('input[type="checkbox"]');
        let $line = $item.closest('.shop-filter-box__line');
        let $button = $line.querySelector('.shop-filter-box__title > button');
        let $content = $line.querySelector('.shop-filter-box__content');
        if (!params) {
          $button.setAttribute('aria-expanded', 'false');
          $content.setAttribute('aria-hidden', 'true');
        };
        if ($item.classList.contains('is-check-all')) {
          this.allChecksArr[name] = [];
        } else if (params) {
          let value = $input.value;
          let isChecked = params.some(v => v === value);
          if (isChecked) {
            $input.checked = true;
            $button.setAttribute('aria-expanded', 'true');
            $content.setAttribute('aria-hidden', 'false');
            $content.style.display = 'block';
          }
        }
        $input.addEventListener('change', event => {
          if ($item.classList.contains('is-check-all')) {
            if ($input.checked) {
              $checksItems.forEach($otherItem => {
                if (!$otherItem.classList.contains('is-check-all')) {
                  let $otherInput = $otherItem.querySelector('input[type="checkbox"]');
                  let otherValue = $otherInput.value;
                  $otherInput.checked = false;
                  this.allChecksArr[name].push(otherValue);
                };
              });
            } else {
              this.allChecksArr[name] = [];
            }
          } else {
            $checksItems.forEach($otherItem => {
              let $otherInput = $otherItem.querySelector('input[type="checkbox"]');
              if ($otherItem.classList.contains('is-check-all')) {
                $otherInput.checked = false;
                this.allChecksArr[name] = [];
              }
            });
          };
        });
      });
    };
  };
  _showShops = $block => {
    let id = $block.getAttribute('id');
    let $items = $block.querySelectorAll('.list-shops-item');
    if (this.params['brand']) {
      let isBrand = this.params['brand'].some(v => v === id);
      if (!isBrand) $block.remove();
    };
    $items.forEach($item => {
      let areaData = $item.dataset.area;
      let moodData = $item.dataset.mood;
      let featureData = $item.dataset.feature;
      let areaArr = areaData.split(',');
      let moodArr = moodData.split(',');
      let featureArr = featureData.split(',');
      let isArea = this.params['area'] ? this.params['area'].some(v => areaArr.includes(v)) : true;
      let isMood = this.params['mood'] ? this.params['mood'].some(v => moodArr.includes(v)) : true;
      let isFeature = this.params['feature'] ? this.params['feature'].some(v => featureArr.includes(v)) : true;
      let isShow = isArea && isMood && isFeature ? true : false;
      if (!isShow) {
        $item.remove();
      };
    });
    let $resultItems = $block.querySelectorAll('.list-shops-item');
    if ($resultItems.length > 0) {
      $block.style.display = 'block';
    } else {
      if (this.params['brand'] || this.params['area'] || this.params['mood'] || this.params['feature']) {
        $block.remove();
      } else {
        $block.style.display = 'block';
      };
    };
  };
  _showResultNumber = () => {
    let $resultItems = this.$result.querySelectorAll('.list-shops-item');
    let resultLen = $resultItems.length;
    this.$resultNum.textContent = resultLen;
    if (resultLen === 0) {
      this.$resultNo.setAttribute('aria-hidden', false);
    };
  };
  _formSubmit = () => {
    const formData = new FormData(this.$form);
    const action = this.$form.getAttribute('action');
    const method = this.$form.getAttribute('method');
    for (const [key, checks] of Object.entries(this.allChecksArr)) {
      if (checks.length) {
        checks.forEach(value => {
          formData.append(`${key}[]`, value);
        });
      };
    };
    const queryString = new URLSearchParams(formData).toString();
    fetch(action, {
      method: method
    }).then(response => {
      if (response.ok) {
        window.location.href = `${action}?${queryString}`;
      } else {
        console.error('Submit Error!');
      };
    }).catch(error => console.error("Error:", error));
  };
};

const $shopFilter = document.querySelectorAll('.shop-filter');
if ($shopFilter) new shopFilter();

// URLに検索条件が含まれている場合
// 対象要素の位置へスムーススクロール
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.search) {
    const target = document.getElementById('shop-filter-below');
    const header = document.querySelector('.l-hd-content') || document.querySelector('header');
    if (target) {
      const headerHeight = header ? header.offsetHeight : 50;
      const targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight - 20;
      window.scrollTo({
        top: Math.max(0, targetPosition),
        behavior: 'instant'
      });
    }
  }
});